import React from "react";

import styles from "./notFoundPage.module.scss";
import { Link, useHistory, useParams } from "react-router-dom";
import Footer from "../Footer/footer";
import translation from "../../Components/Helpers/translation";
import SeoHeader from "../../Components/SeoHeader/seoHeader";

function NotFoundPage() {
    const { lang } = useParams();
    const history = useHistory();

    return (
        <>
            <SeoHeader
                title={`${translation.seo.titles.siteTitle.notFound} - ${translation.seo.titles.mainTitle}`}
                description={translation.all.notFound.description}
            />
            <div className={styles.wrapper}>
                <main className={styles.main}>
                    <div className={styles.container}>
                        <span className={styles.code}>404</span>
                        <h1 className={styles.title}>{translation.all.notFound.title}</h1>
                        <p className={styles.description}>{translation.all.notFound.description}</p>
                        <div className={styles.actions}>
                            <Link to={`/${lang}`} className={styles.primaryLink}>
                                {translation.all.notFound.goHome}
                            </Link>
                            <button type="button" className={styles.secondaryButton} onClick={() => history.goBack()}>
                                {translation.all.goBack}
                            </button>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
}

export default NotFoundPage;
